/**
 * The shape of the task field set, shared by adding, editing and resolving an inbox item.
 *
 * Separate from the components so `TaskFields.tsx` exports components only — React Fast
 * Refresh cannot hot-swap a module that also exports values (D48).
 */

import { EMPTY_RECURRENCE, type RecurrenceFormValues } from "./recurrence";

export type TaskFieldValues = {
  destination: string;
  energy: number | null;
  important: boolean;
  starred: boolean;
  due: string;
  snoozed: string;
  estimate: string;
  /** §4.6: the recurrence section, collapsed (not `enabled`) until the owner opts in. */
  recurrence: RecurrenceFormValues;
  notes: string;
};

export const EMPTY_FIELDS: TaskFieldValues = {
  destination: "",
  energy: null,
  important: false,
  starred: false,
  due: "",
  snoozed: "",
  estimate: "",
  recurrence: EMPTY_RECURRENCE,
  notes: "",
};

/** Activation cost levels (§8.3). */
export const ENERGY_LEVELS = [1, 2, 3, 4, 5];
